import cx from 'classnames';
import LogoSVG from 'themes/common/assets/logos/GGLogo-full.svg';

import { useFooter } from 'hooks/page/footer/useFooter';

import { ContentContainer } from '../ContentContainer';

import s from './OrganicFooter.module.css';

export const OrganicFooter = () => {
  const {
    address,
    addressLink,
    privacyPolicyUrl,
    showAddress,
    termsOfServiceUrl,
  } = useFooter();

  return (
    <footer className={cx(s.root)}>
      <ContentContainer>
        <div className={s.content}>
          {showAddress && (
            <a
              href={addressLink}
              className={s.address}
              target="_blank"
              rel="noreferrer"
            >
              {address}
            </a>
          )}

          <a
            className={s.logo}
            href="https://glossgenius.com"
            target="_blank"
            rel="noreferrer"
          >
            <span aria-hidden>powered by</span>
            <LogoSVG title="powered by Gloss Genius" />
          </a>

          <div className={s.links}>
            <a
              className={s.termsLink}
              href={termsOfServiceUrl}
              target="_blank"
              rel="noreferrer"
            >
              Terms
            </a>
            <a
              className={s.privacyLink}
              href={privacyPolicyUrl}
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>
          </div>
        </div>
      </ContentContainer>
    </footer>
  );
};
